import React, { useState, useContext, useEffect } from "react";
import {
  Col,
  Container,
  Row,
  Button,
  Card,
  CardBody,
  CardTitle,
  Input,
  Spinner,
} from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";
import { Tooltip } from "react-tooltip";
import {
  useUpdateDeviceTypeMutation,
  useGetDeviceRedeemTokenQuery,
} from "slices/employee/employeeSlice";
import { ServiceContext } from "context/ServiceContextProvider";
import QR from "../../assets/images/companies/Apple.png";
import AndroidQR from "../../assets/images/companies/android_app.png";

const MobileAppLink = () => {
  const [selectedDevice, setSelectedDevice] = useState("");
  const [tooltipContent, setTooltipContent] = useState("Copy");

  const [isModalOpen, setIsModalOpen] = useState(false);

  const { getEmployeeUUID } = useContext(ServiceContext);

  const {
    data: deviceTokenInfo,
    isLoading,
    refetch,
  } = useGetDeviceRedeemTokenQuery(undefined);

  console.log("deviceTokenInfo", deviceTokenInfo);

  const handleCopy = () => {
    const copyText =
      "https://play.google.com/store/apps/details?id=com.puretechmobileapp&hl=en-US&pli=1";
    navigator.clipboard.writeText(copyText);
    setTooltipContent("Copied!");
    setTimeout(() => setTooltipContent("Copy"), 2000);
  };

  const handleIosCopy = () => {
    const copyText =
      "https://apps.apple.com/gb/app/complipro-plus/id6743641749";
    navigator.clipboard.writeText(copyText);
    setTooltipContent("Copied!");
    setTimeout(() => setTooltipContent("Copy"), 2000);
  };

  if (isLoading) {
    return (
      <Container fluid>
        <BreadCrumb title="Mobile App" pageTitle="Dashboard" />
        <Row>
          <Spinner />
        </Row>
      </Container>
    );
  }

  return (
    <React.Fragment>
      <Tooltip
        style={{ zIndex: 10 }}
        anchorSelect=".copy-link-class"
        content={tooltipContent}
      />

      <div className="page-content">
        <Container fluid>
          <BreadCrumb title="Mobile App" pageTitle="Dashboard" />

          <Row>
            <Col>
              {/* Android Section */}
              <Card className="mt-4">
                <CardBody>
                  <CardTitle tag="h5">
                    <h2>
                      <i className="ri-android-line text-success"></i> Android
                      App
                    </h2>
                  </CardTitle>
                  <Row>
                    <Col
                      md={12}
                      className="d-flex align-items-center justify-content-center"
                    >
                      <div>
                        <p>
                          Scan QR to Download CompliPro Plus app from{" "}
                          <i className="ri-android-line text-success"></i> Play
                          Store.
                        </p>
                        <label>Download Link:</label>
                        <div className="d-flex align-items-center">
                          <Input
                            type="text"
                            value={
                              "https://play.google.com/store/apps/details?id=com.puretechmobileapp&hl=en-US&pli=1"
                            }
                            readOnly
                            className="mt-2 me-2"
                          />
                          <Button
                            color="secondary"
                            className="mt-2 d-flex align-items-center copy-link-class"
                            onClick={handleCopy}
                          >
                            <i className="ri-file-copy-line me-1 align-bottom text-white"></i>
                          </Button>
                        </div>
                        <div className="mt-5 text-center">
                          <h6>
                            Scan to Download <strong>CompliPro Plus</strong>{" "}
                            App:
                          </h6>
                          <img
                            src={AndroidQR}
                            width={200}
                            height={200}
                            alt="QR Code"
                            className="img-fluid rounded"
                          />
                        </div>
                        <a
                          href={
                            "https://play.google.com/store/apps/details?id=com.puretechmobileapp&hl=en-US&pli=1"
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          https://play.google.com/store/apps/details?id=com.puretechmobileapp&hl=en-US&pli=1
                        </a>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col
                      md="12"
                      className="d-flex align-items-center justify-content-center"
                    >
                      <div className="steps mt-4">
                        <h6>Steps to Download the App:</h6>
                        <ol>
                          <li>
                            Scan the <strong>QR code</strong> above using your
                            mobile device's camera.
                          </li>
                          <li>
                            Open the link in the{" "}
                            <strong>Google Play Store</strong> (Android).
                          </li>
                          <li>
                            <strong>Download</strong> and install the app on
                            your device.
                          </li>
                        </ol>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>

              {/* iOS Section */}
              <Card className="mt-4">
                <CardBody>
                  <CardTitle tag="h5">
                    <h2>
                      <i className="ri-apple-fill text-black"></i> iOS App
                    </h2>
                  </CardTitle>
                  <Row>
                    <Col
                      md="12"
                      className="d-flex align-items-center justify-content-center"
                    >
                      <div className="mt-3">
                        <p>
                          Scan QR to Download CompliPro Plus app from{" "}
                          <i className="ri-apple-fill text-black"></i> App
                          Store.
                        </p>
                        <label>Download Link :</label>
                        <div className="d-flex align-items-center">
                          <Input
                            type="text"
                            value={
                              "https://apps.apple.com/gb/app/complipro-plus/id6743641749"
                            }
                            readOnly
                            className="mt-2 me-2"
                          />
                          <Button
                            color="secondary"
                            className="mt-2 d-flex align-items-center copy-link-class"
                            onClick={handleIosCopy}
                          >
                            <i className="ri-file-copy-line me-1 align-bottom text-white"></i>
                          </Button>
                        </div>
                        <div className="mt-5 text-center">
                          <h6>
                            Scan to Download <strong>CompliPro Plus </strong>{" "}
                            App:
                          </h6>
                          <br></br>
                          <img
                            src={QR}
                            width={200}
                            height={200}
                            alt="QR Code"
                            className="img-fluid rounded"
                          />
                        </div>
                        <br></br>
                        <a
                          href={
                            "https://apps.apple.com/gb/app/complipro-plus/id6743641749"
                          }
                          target="_blank"
                          rel="noreferrer"
                        >
                          https://apps.apple.com/gb/app/complipro-plus/id6743641749
                        </a>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col
                      md="12"
                      className="d-flex align-items-center justify-content-center"
                    >
                      <div className="steps mt-4">
                        <h6>Steps to Download the App:</h6>
                        <ol>
                          <li>
                            Scan the <strong>QR code</strong> above using your
                            iOS device's camera.
                          </li>
                          <li>
                            Open the link in the <strong>App Store</strong>{" "}
                            (iOS).
                          </li>

                          <li>
                            <strong>Download</strong> and install the app on
                            your device.
                          </li>
                        </ol>
                      </div>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default MobileAppLink;
